import {
  LOAD_A2A_EMPLOYEE_REQUEST,
  LOAD_A2A_EMPLOYEE_SUCCESS,
  LOAD_A2A_MAPPING_ERROR,
  LOAD_A2A_MAPPING_LOADING,
  LOAD_A2A_MAPPING_SUCCESS,
  LOAD_A2A_PAY_TYPE_REQUEST,
  LOAD_A2A_PAY_TYPE_SUCCESS,
  LOAD_ACCOUNT_COMPANY_FILE_REQUEST,
  LOAD_ACCOUNT_COMPANY_FILE_SUCCESS,
  LOAD_ACCOUNT_EMPLOYEE_REQUEST,
  LOAD_ACCOUNT_EMPLOYEE_SUCCESS,
  LOAD_ACCOUNT_PAY_TYPE_REQUEST,
  LOAD_ACCOUNT_PAY_TYPE_SUCCESS,
  LOAD_ACCOUNT_TAX_CODE_REQUEST,
  LOAD_ACCOUNT_TAX_CODE_SUCCESS,
  LOAD_INVOICE_RECONCILIATION_REPORT_REQUEST,
  LOAD_INVOICE_RECONCILIATION_REPORT_SUCCESS,
  SAVE_ACCOUNT_EMPLOYEE_LIST_STATUS,
  SAVE_ACCOUNT_PAY_TYPE_LIST_STATUS,
  SEND_A2A_EMPLOYEE_REQUEST,
  SEND_A2A_PAY_TYPE_REQUEST,
  SEND_ACCOUNT_COMPANY_FILE_REQUEST,
  SEND_ACCOUNT_TAX_CODE_REQUEST,
} from '../constant/a2aMappingConstant';

export function loadA2AMappingLoading(data) {
  return {
    type: LOAD_A2A_MAPPING_LOADING,
    payload: data,
  }
};

export function loadA2AMappingError(data) {
  return {
    type: LOAD_A2A_MAPPING_ERROR,
    payload: data,
  }
};

export function loadA2AMappingSuccess(data) {
  return {
    type: LOAD_A2A_MAPPING_SUCCESS,
    payload: data,
  }
};

export function saveAccountEmployeeListStatus(data) {
  return {
    type: SAVE_ACCOUNT_EMPLOYEE_LIST_STATUS,
    payload: data,
  }
};

export function loadAccountEmployeeRequest(data) {
  return {
    type: LOAD_ACCOUNT_EMPLOYEE_REQUEST,
    payload: data,
  }
};

export function loadAccountEmployeeSuccess(data) {
  return {
    type: LOAD_ACCOUNT_EMPLOYEE_SUCCESS,
    payload: data,
  }
};

export function loadMappingEmployeeRequest(data) {
  return {
    type: LOAD_A2A_EMPLOYEE_REQUEST,
    payload: data,
  }
};

export function loadMappingEmployeeSuccess(data) {
  return {
    type: LOAD_A2A_EMPLOYEE_SUCCESS,
    payload: data,
  }
};

export function sendMappingEmployeeRequest(data) {
  return {
    type: SEND_A2A_EMPLOYEE_REQUEST,
    payload: data,
  }
};

export function saveAccountPayTypeListStatus(data) {
  return {
    type: SAVE_ACCOUNT_PAY_TYPE_LIST_STATUS,
    payload: data,
  }
};

export function loadAccountPayTypeRequest(data) {
  return {
    type: LOAD_ACCOUNT_PAY_TYPE_REQUEST,
    payload: data,
  }
};

export function loadAccountPayTypeSuccess(data) {
  return {
    type: LOAD_ACCOUNT_PAY_TYPE_SUCCESS,
    payload: data,
  }
};

export function loadMappingPayTypeRequest(data) {
  return {
    type: LOAD_A2A_PAY_TYPE_REQUEST,
    payload: data,
  }
};

export function loadMappingPayTypeSuccess(data) {
  return {
    type: LOAD_A2A_PAY_TYPE_SUCCESS,
    payload: data,
  }
};

export function sendMappingPayTypeRequest(data) {
  return {
    type: SEND_A2A_PAY_TYPE_REQUEST,
    payload: data,
  }
};

export function loadCompanyFileRequest(data) {
  return {
    type: LOAD_ACCOUNT_COMPANY_FILE_REQUEST,
    payload: data,
  }
};

export function loadCompanyFileSuccess(data) {
  return {
    type: LOAD_ACCOUNT_COMPANY_FILE_SUCCESS,
    payload: data,
  }
};

export function sendCompanyFileRequest(data) {
  return {
    type: SEND_ACCOUNT_COMPANY_FILE_REQUEST,
    payload: data,
  }
};

export function loadTaxCodeRequest(data) {
  return {
    type: LOAD_ACCOUNT_TAX_CODE_REQUEST,
    payload: data,
  }
};

export function loadTaxCodeSuccess(data) {
  return {
    type: LOAD_ACCOUNT_TAX_CODE_SUCCESS,
    payload: data,
  }
};

export function sendTaxCodeRequest(data) {
  return {
    type: SEND_ACCOUNT_TAX_CODE_REQUEST,
    payload: data,
  }
};

export function loadInvoiceReconciliationReportRequest(data) {
  return {
    type: LOAD_INVOICE_RECONCILIATION_REPORT_REQUEST,
    payload: data,
  }
};

export function loadInvoiceReconciliationReportSuccess(data) {
  return {
    type: LOAD_INVOICE_RECONCILIATION_REPORT_SUCCESS,
    payload: data,
  }
};
